<script setup lang="ts">
import { useCurrentUser } from "@/api/current-user";
import { Scheduler } from "@soft-db/monitoring-api-client";
import { DateTime } from "luxon";
import { PropType } from "vue";

const props = defineProps({
	scheduler: {
		type: Object as PropType<Scheduler | null>,
		reqired: false,
	},
});

const scheduler = computed(() => props.scheduler);

const { t } = useI18n();

const { data: user } = useCurrentUser();

function arrayEquals(a: number[], b: number[]) {
	return a.length === b.length && a.every((val, index) => val === b[index]);
}
function formatWeekdays(weekdays: number[]) {
	const weekLabel = [
		t("common.sunday"),
		t("common.monday"),
		t("common.tuesday"),
		t("common.wednesday"),
		t("common.thursday"),
		t("common.friday"),
		t("common.saturday"),
	];
	return weekdays.map((i) => weekLabel[i]).join(", ");
}
function formatTime(value: number) {
	const hour = Math.floor(value / 60);
	const minute = value % 60;

	const formattedTime = DateTime.now()
		.set({ hour, minute })
		.toLocaleString(DateTime.TIME_SIMPLE, { locale: user.value?.preferredLang });

	return formattedTime;
}
function formatLabel(scheduler: Scheduler) {
	const weekdays = [1, 2, 3, 4, 5];
	const weekend = [0, 6];

	let week = "";
	if (scheduler.weekdays.length === 7) {
		week = t("alert-settings.allWeek").toLowerCase();
	} else if (arrayEquals(scheduler.weekdays, weekdays)) {
		week = t("alert-settings.onWeekdays").toLowerCase();
	} else if (arrayEquals(scheduler.weekdays, weekend)) {
		week = t("alert-settings.onWeekends").toLowerCase();
	} else {
		week = `${t("alert-settings.on").toLowerCase()} ${formatWeekdays(scheduler.weekdays)}`;
	}

	const time = `${t("project-settings.from").toLowerCase()} ${formatTime(scheduler.start)} ${t("project-settings.to").toLowerCase()} ${formatTime(scheduler.end)}`;

	return `${t("object.alert")} ${t("alert-settings.active").toLowerCase()} ${week} ${time}`;
}

const schedulerLabel = computed(() => {
	if (!scheduler.value) return t("alert-settings.noScheduler");

	return formatLabel(scheduler.value);
});
</script>

<template>
	<span>{{ schedulerLabel }}</span>
</template>
